import { Div, Icon } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { useGetMyGames } from "./useGetMyGames";
import MyGamesList from "./MyGamesList";
import { useMemo, useState } from "react";
import { Tab, TabTopBar } from "../../layout/components/tab";

export default function MyGamesScreen({ navigation }: MainStackScreenProps<"my-games">) {
  const { loading, games } = useGetMyGames();
  const [activeTab, setActiveTab] = useState(0);

  const openGame = (gameId: number) => {
    navigation.navigate("game", { id: gameId });
  };

  const tabs: Tab[] = useMemo(() => {
    return [
      {
        key: "upcoming",
        title: "UPCOMING",
        renderComponent: () => (
          <MyGamesList
            key={0}
            games={games?.filter((g) => (g.datetime || new Date().toISOString()) > new Date().toISOString())}
            loading={loading}
            onGamePress={openGame}
          />
        ),
      },
      {
        key: "past",
        title: "PAST",
        renderComponent: () => (
          <MyGamesList
            key={1}
            games={games?.filter((g) => (g.datetime || new Date().toISOString()) < new Date().toISOString())}
            loading={loading}
            onGamePress={openGame}
          />
        ),
      },
    ];
  }, [games, loading]);

  return (
    <ScreenLayout
      header={{ center: "MY GAMES", left: <Icon name="menu" size={24} onPress={navigation.toggleDrawer} /> }}
    >
      <Div classNames={["flexRow", "bgNeutralDarkerDark", "mb-{8}"]}>
        {tabs.map((tab, index) => (
          <TabTopBar key={index} isActive={activeTab == index} tab={tab} onPress={() => setActiveTab(index)} />
        ))}
      </Div>
      {tabs.map((tab, index) => (index === activeTab ? tab.renderComponent() : null))}
    </ScreenLayout>
  );
}
